var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 1.25H2.45C2.02996 1.25 1.81994 1.25 1.65951 1.33175C1.51839 1.40365 1.40365 1.51839 1.33175 1.65951C1.25 1.81994 1.25 2.02996 1.25 2.45V5.3C1.25 5.72004 1.25 5.93006 1.33175 6.09049C1.40365 6.23161 1.51839 6.34635 1.65951 6.41826C1.81994 6.5 2.02996 6.5 2.45 6.5H5.3C5.72004 6.5 5.93006 6.5 6.09049 6.41826C6.23161 6.34635 6.34635 6.23161 6.41826 6.09049C6.5 5.93006 6.5 5.72004 6.5 5.3V2.45C6.5 2.02996 6.5 1.81994 6.41826 1.65951C6.34635 1.51839 6.23161 1.40365 6.09049 1.33175C5.93006 1.25 5.72004 1.25 5.3 1.25Z",
    stroke: "#777777",
    strokeWidth: 1.56777,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.55 1.25H10.7C10.28 1.25 10.0699 1.25 9.90951 1.33175C9.76839 1.40365 9.65365 1.51839 9.58175 1.65951C9.5 1.81994 9.5 2.02996 9.5 2.45V5.3C9.5 5.72004 9.5 5.93006 9.58175 6.09049C9.65365 6.23161 9.76839 6.34635 9.90951 6.41826C10.0699 6.5 10.28 6.5 10.7 6.5H13.55C13.97 6.5 14.1801 6.5 14.3405 6.41826C14.4816 6.34635 14.5964 6.23161 14.6683 6.09049C14.75 5.93006 14.75 5.72004 14.75 5.3V2.45C14.75 2.02996 14.75 1.81994 14.6683 1.65951C14.5964 1.51839 14.4816 1.40365 14.3405 1.33175C14.1801 1.25 13.97 1.25 13.55 1.25Z",
    stroke: "#777777",
    strokeWidth: 1.56777,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.55 9.5H10.7C10.28 9.5 10.0699 9.5 9.90951 9.58175C9.76839 9.65365 9.65365 9.76839 9.58175 9.90951C9.5 10.0699 9.5 10.28 9.5 10.7V13.55C9.5 13.97 9.5 14.1801 9.58175 14.3405C9.65365 14.4816 9.76839 14.5964 9.90951 14.6683C10.0699 14.75 10.28 14.75 10.7 14.75H13.55C13.97 14.75 14.1801 14.75 14.3405 14.6683C14.4816 14.5964 14.5964 14.4816 14.6683 14.3405C14.75 14.1801 14.75 13.97 14.75 13.55V10.7C14.75 10.28 14.75 10.0699 14.6683 9.90951C14.5964 9.76839 14.4816 9.65365 14.3405 9.58175C14.1801 9.5 13.97 9.5 13.55 9.5Z",
    stroke: "#777777",
    strokeWidth: 1.56777,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.3 9.5H2.45C2.02996 9.5 1.81994 9.5 1.65951 9.58175C1.51839 9.65365 1.40365 9.76839 1.33175 9.90951C1.25 10.0699 1.25 10.28 1.25 10.7V13.55C1.25 13.97 1.25 14.1801 1.33175 14.3405C1.40365 14.4816 1.51839 14.5964 1.65951 14.6683C1.81994 14.75 2.02996 14.75 2.45 14.75H5.3C5.72004 14.75 5.93006 14.75 6.09049 14.6683C6.23161 14.5964 6.34635 14.4816 6.41826 14.3405C6.5 14.1801 6.5 13.97 6.5 13.55V10.7C6.5 10.28 6.5 10.0699 6.41826 9.90951C6.34635 9.76839 6.23161 9.65365 6.09049 9.58175C5.93006 9.5 5.72004 9.5 5.3 9.5Z",
    stroke: "#777777",
    strokeWidth: 1.56777,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDash);
export default __webpack_public_path__ + "static/media/dash.0f75728b58b50ff30370546d26d7e219.svg";
export { ForwardRef as ReactComponent };